import script from "./JaContentConfirm.vue?vue&type=script&setup=true&lang=js"
export * from "./JaContentConfirm.vue?vue&type=script&setup=true&lang=js"

import "./JaContentConfirm.vue?vue&type=style&index=0&id=621335d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-621335d8"]])

export default __exports__